import { render, staticRenderFns } from "./EditBill.vue?vue&type=template&id=24bdcd95&scoped=true"
import script from "./EditBill.vue?vue&type=script&lang=js"
export * from "./EditBill.vue?vue&type=script&lang=js"
import style0 from "./EditBill.vue?vue&type=style&index=0&id=24bdcd95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bdcd95",
  null
  
)

export default component.exports